export interface BookAppointmentOnlineOptionItemDefinition {
    id: string;
    name: string;
    price?: string;
    duration?: string;
    priceFrom?: string;
    priceTo?: string;
    durationFrom?: string;
    durationTo?: string;
    description?: string;
}

export class BookAppointmentOnlineOptionItemModel {
    private id: string;
    private name: string;
    private duration?: string;
    private price?: string;
    private priceFrom?: string;
    private priceTo?: string;
    private durationFrom?: string;
    private durationTo?: string;
    private description?: string;

    constructor(definition: BookAppointmentOnlineOptionItemDefinition) {
        Object.keys(definition).forEach((name: string) => {
            this[name] = definition[name];
        });
    }

    public getId(): string {
        return this.id;
    }
    public getName(): string {
        return this.name;
    }
    public getPrice(): string | null {
        return this.price;
    }
    public getDuration(): string | null {
        return this.duration;
    }
    public getPriceFrom(): string | null {
        return this.priceFrom ?? this.price;
    }
    public getPriceTo(): string | null {
        return this.priceTo ?? this.price;
    }
    public getDurationFrom(): string | null {
        return this.durationFrom ?? this.duration;
    }
    public getDurationTo(): string | null {
        return this.durationTo ?? this.duration;
    }
    public getDescription(): string | null {
        return this.description;
    }

}
